import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface LoadingSpinnerProps {
}

const defaultProps = {
};

const LoadingSpinner = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
};

LoadingSpinner.defaultProps = defaultProps as unknown as Partial<LoadingSpinnerProps>;

export default LoadingSpinner;
